/* eslint-disable react-hooks/exhaustive-deps */
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import { DateRangePicker } from "react-date-range";
import { Helmet } from "react-helmet";

/* MATERIAL TAILWIND COMPONENTS */
import { Button, Tooltip } from "@material-tailwind/react";

/* ICONS */
import { FaCalendar } from "react-icons/fa6";
import { IoEyeSharp } from "react-icons/io5";
import { TbFileInvoice } from "react-icons/tb";

/* DATA */

/* USER DEFINED COMPONENTS */
import { Link } from "react-router-dom";
import InputField from "../../../components/input";
import { SET_FORMAT } from "../../../config";
import { getOrdersList } from "../../../service/api";

/* LOADING SCREEN FOR DATATABLE */
  const LoadingScreen = () => {
    return (
      <div className="w-full bg-[#F5F5F5] bg-opacity-50 rounded-md border border-authBorder py-5">
        <p className="text-sm font-proxima-semibold text-black text-center">
          Please wait!
        </p>
        <p className="text-sm font-proxima-semibold text-black text-center">
          We are fetching data{" "}
        </p>
      </div>
    );
  };

  const NoDataScreen = () => {
    return (
      <div className="w-full bg-[#F5F5F5] bg-opacity-50 rounded-md border border-authBorder py-5">
        <p className="text-sm font-proxima-semibold text-black text-center">
          There are no queries to display.
        </p>
      </div>
    );
  };

/* CLICK OUTSIDE HANDLER */
const useClickOutside = (handler) => {
  let domNode = useRef();

  useEffect(() => {
    let maybeHandler = (event) => {
      if (!domNode.current?.contains(event.target)) {
        handler();
      }
    };

    document.addEventListener("mousedown", maybeHandler);
    return () => {
      document.removeEventListener("mousedown", maybeHandler);
    };
  });

  return domNode;
};

const Orders = () => {
  /* DATEPICKER VARIABES */
  const [datepicker, setDatepicker] = useState(false);
  const [startDate, setStartDate] = useState(
    moment(new Date().setMonth(new Date().getMonth() - 1)).format("DD/MM/YYYY")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("DD/MM/YYYY")
  );

  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [ordersList, setOrdersList] = useState([]);
  console.log("🚀 ~ Orders ~ ordersList:", ordersList)
  const [totalDocs, setTotalDocs] = useState([]);

  let domNode = useClickOutside(() => {
    setDatepicker(false);
  });

  const selectionRange = {
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  };

  /* COLUMNS */
  const columns = [
    {
      name: "Order ID",
      grow: 1,
      selector: (row) => (
        <span className="text-sm font-proxima-semibold text-black text-opacity-60">
          {row?.orderId}
        </span>
      ),
    },
    {
      name: "Customer Name",
      grow: 1.3,
      selector: (row) => (
        <span className="text-sm font-proxima-bold text-black text-opacity-90">
          {row?.personalDetails?.firstName + " " + row?.personalDetails?.lastName}
        </span>
      ),
    },
    {
      name: "Customer Email",
      width: "25vh",
      selector: (row) => (
        <span className="text-sm font-proxima-semibold text-black text-opacity-60">
          {row?.personalDetails?.email}
        </span>
      ),
    },
    {
      name: "Customer Phone",
      selector: (row) => (
        <span className="text-sm font-proxima-semibold text-black text-opacity-60">
          {row?.personalDetails?.phoneNumber}
        </span>
      ),
    },
    {
      name: "Purchase Date",
      grow: 1.3,
      selector: (row) => (
        <span className="text-sm font-proxima-semibold text-black text-opacity-60">
          {moment(row?.createdAt).format("DD MMM' YYYY hh:mm a")}
        </span>
      ),
    },
    {
      name: "Amount",
      width: "15vh",
      selector: (row) => (
        <span className="text-sm font-proxima-bold text-black">
          {SET_FORMAT(row?.amount)}
        </span>
      ),
    },
    {
      name: "Payment Status",
      selector: (row) =>
        row.paymentStatus === "Cash on Delivery" ? (
          <span className="text-sm font-proxima-semibold text-orange-800">
            {row?.orderStatus}
          </span>
        ) : (
          <span className="text-sm font-proxima-semibold text-green-500">
            {row?.orderStatus}
          </span>
        ),
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="flex items-center">
          <Tooltip
            content="View order details"
            className="text-sm font-proxima-semibold"
          >
            <Link to={`/order/${row?._id}`}>
              <Button className="p-2 rounded-full shadow-none hover:shadow-none bg-transparent hover:bg-black hover:bg-opacity-5">
                <IoEyeSharp className="w-5 h-5 text-greyText" />
              </Button>
            </Link>
          </Tooltip>
          <Tooltip
            content="View invoice"
            className="text-sm font-proxima-semibold"
          >
            <Button className="p-2 rounded-full shadow-none hover:shadow-none bg-transparent hover:bg-black hover:bg-opacity-5">
              <TbFileInvoice className="w-5 h-5 text-greyText" />
            </Button>
          </Tooltip>
        </div>
      ),
    },
  ];

    /* FUNCTIONS */
  const handlePageChange = async (e) => {
    setPage(e);
    getOrdersListFunction();
  };

  const handlePerPageChange = async (e) => {
    setSizePerPage(e);
    getOrdersListFunction();
  };

  const getOrdersListFunction = () => {
    setLoading(true);
    const params = {
      page: page,
      sizePerPage: sizePerPage,
      pagination: true,
    };

    getOrdersList(params)
      .then((res) => {
        setOrdersList(res?.data?.docs);
        setTotalDocs(res?.data?.totalDocs);
      })
      .catch((e) => {
        console.log("e-->", e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getOrdersListFunction();
  }, []);

  return (
    <section className="px-0 py-2 xl:p-10 lg:p-10 min-h-screen xl:min-h-full lg:min-h-full">
      {/* PAGE TITLE */}
      <Helmet>
        <title>Orders | Fashion N Fun</title>
      </Helmet>

      <div className="container-full-width">
        <div className="block xl:flex lg:flex items-center justify-between">
          {/* HEADING */}
          <div>
            <h1 className="text-3xl font-proxima-bold text-black tracking-tight">
              Customer Orders
            </h1>
            <h2 className="text-base xl:text-lg lg:text-lg font-proxima-regular text-greyText tracking-tight">
              Manage the orders placed by the customers from your website
            </h2>
          </div>

          {/* SEARCH AND FILTERS */}
          <div className="block xl:flex lg:flex items-center gap-2 mt-2 xl:mt-0 lg:mt-0">
            {/* SEARCHBAR */}
            <div className="w-full xl:w-searchBar lg:w-searchBar">
              <InputField
                type="text"
                placeholder="Search your order"
                name="search"
                id="search"
              />
            </div>

            {/* RANGEPICKER */}
            <div className="relative mt-2 xl:mt-0 lg:mt-0 w-full xl:w-auto lg:w-auto">
              <div
                ref={domNode}
                className="w-full xl:w-rangePicker lg:w-rangePicker flex items-center gap-3 border border-authBorder rounded-lg py-3 px-5 bg-white cursor-pointer"
              >
                <FaCalendar className="w-4 h-4 text-greyText" />
                <input
                  type="text"
                  name="dateRange"
                  placeholder="Select the date range"
                  value={`${startDate} - ${endDate}`}
                  onClick={() => setDatepicker(!datepicker)}
                  className="w-full bg-white outline-none font-proxima-semibold text-sm focus:outline-none active:outline-none placeholder:font-proxima-regular transition-all duration-300 ease-linear text-black"
                />
              </div>
              {datepicker && (
                <div className="absolute top-12 right-0 transition-all duration-300 ease-linear z-50">
                  <DateRangePicker
                    ranges={[selectionRange]}
                    dragSelectionEnabled
                    showPreview
                    onChange={(e) => {
                      setStartDate(
                        moment(e.selection.startDate).format("DD/MM/YYYY")
                      );
                      setEndDate(
                        moment(e.selection.endDate).format("DD/MM/YYYY")
                      );
                    }}
                    className="shadow-xl font-proxima-regular rounded-xl border border-authBorder cursor-pointer"
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ORDERS TABLE */}
        <div className="mt-5">
          <DataTable
            className="data-table"
            data={totalDocs > 0 ? ordersList : []}
            columns={columns}
            progressComponent={<LoadingScreen />}
            progressPending={loading}
            responsive
            pagination
            paginationServer
            paginationTotalRows={totalDocs}
            onChangeRowsPerPage={handlePerPageChange}
            onChangePage={handlePageChange}
            noDataComponent={<NoDataScreen />}
          />
        </div>
      </div>
    </section>
  );
};

export default Orders;
